export default __webpack_public_path__ + "static/media/color-wheel.061704f0.svg";